import React from 'react'

import {
    COLOR,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    //GridItem1,
    GridItem3,
    GridItem5,
    GridItem6,
    GridItem7,
    GridItem8,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao,
} from '../../../business-components/Chart/Chart'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'

import {
    calculaValorPremioAnualizadoVidaInteira,
    calculaValorCSVidaInteira,
} from '../estudo-form/EstudoServiceGarantiasRecursosFinanceiros'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import GestaoPatrimonialFormResumoPatrimonial from '../gestaoPatrimonial-form/GestaoPatrimonialFormResumoPatrimonial'

import GestaoPatrimonialFormResumoPatrimonialTotalAtivos
    from '../gestaoPatrimonial-form/GestaoPatrimonialFormResumoPatrimonialTotalAtivos'

import AnalisePatrimonialPieChart from './AnalisePatrimonialPieChart'

import RecursosFinanceirosChart from './RecursosFinanceirosChart'



const AnalisePatrimonialChart = ( { values, setFieldValue, estudo, report, naoExibirTabela,
    moreLessList, semAlavancagem } ) => {

    const AnalisePatrimonial = ( /*props*/ ) => {

        let valorPremioAnualizadoVidaInteira = calculaValorPremioAnualizadoVidaInteira(values)

        const series = []
        const paletaCoresEspecifica = [
            COLOR().corChartPadraoAnalisePatrimonialAtivosPatrimonioImobilizado,
            COLOR().corChartPadraoAnalisePatrimonialAtivosRecursosFinanceiros,
        ]

        series.push(
            {
                name: LABEL.patrimonioImobilizado,
                type: 'bar',
                data: [
                    estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoPatrimonioImobilizado].valorAcumuladoPainel,
                    0,
                    0,
                ],
            },
        )

        series.push(
            {
                name: LABEL.recursosFinanceiros,
                type: 'bar',
                data: [
                    estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoRecursosFinanceiros].valorAcumuladoPainel -
                        (semAlavancagem ? 0 : valorPremioAnualizadoVidaInteira),
                    null,
                    null,
                ],
            },
        )

        let valorCSVidaInteira = calculaValorCSVidaInteira(values, semAlavancagem)

        if (values.exibirCapitalSeguradoCarteiraInvestimentos && !semAlavancagem) {

            if (values.valorCSVidaInteiraApoliceCliente + values.valorCSVidaInteiraApoliceConjuge > 0) {

                series.push(
                    {
                        name: LABEL.vidaInteira,
                        type: 'bar',
                        data: [
                            values.valorCSVidaInteiraApoliceCliente + values.valorCSVidaInteiraApoliceConjuge,
                            0,
                            0,
                        ],
                    },
                )

                paletaCoresEspecifica.push(
                    COLOR().corChartPadraoVidaInteira,
                )
            }

            if (existeTabelaEvolucaoValorResgate(values)) {

                if (values.valorCSVidaInteiraCotacaoCliente + values.valorCSVidaInteiraCotacaoConjuge > 0) {

                    series.push(
                        {
                            name: LABEL.cotacao  + ' ' + LABEL.vidaInteira,
                            type: 'bar',
                            data: [
                                values.valorCSVidaInteiraCotacaoCliente + values.valorCSVidaInteiraCotacaoConjuge,
                                0,
                                0,
                            ],
                        },
                    )

                    paletaCoresEspecifica.push(
                        COLOR().corChartPadraoVidaInteiraCotacao,
                    )
                }
            }
        }
        
        series.push(
            {
                name: LABEL.financiamento,
                type: 'bar',
                data: [
                    null,
                    estudo.current.valorFinanciamentoAnalisePatrimonial,
                    null,
                ],
            },
        )

        series.push(
            {
                name: LABEL.ativosMenosPassivos,
                type: 'bar',
                data: [
                    null,
                    null,
                    estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoPatrimonioImobilizado].valorAcumuladoPainel +
                    estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoRecursosFinanceiros].valorAcumuladoPainel +
                    valorCSVidaInteira -
                    valorPremioAnualizadoVidaInteira -
                    estudo.current.valorFinanciamentoAnalisePatrimonial,
                ],
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoAnalisePatrimonialPassivos,
            COLOR().corChartPadraoAnalisePatrimonialSaldoPatrimonial,
        )

        const categories = [
            LABEL.ativos,
            LABEL.passivos,
            LABEL.ativosMenosPassivos
        ]



        const GridGrafico = report ? GridItem10 : GridItem12
        ////const GridTotalAtivos = report ? GridItem12 : GridItem4
        ////const GridGraficoRecursosInstituicao = report ? GridItem4 : GridItem3
        ////const GridGraficoRecursosDescricaoTipoFinanciamento = report ? GridItem4 : GridItem3
        const GridGraficoRecursosInstituicao = report ? GridItem12 : GridItem6
        const GridGraficoRecursosDescricaoTipoFinanciamento = report ? GridItem12 : GridItem6


        
        return (
            //<div
            //    {...props}
            //>
                <GridContainer>
                    <GridGrafico>
                        <GridContainer>
                            <GridItem8>
                                <ChartPadrao
                                    titleText={''} // mudança da fonte: titleText={LABEL.analisePatrimonial}
                                    type={"area"}
                                    series={series}
                                    stacked={true}
                                    categories={categories}
                                    paletaCores={paletaCoresEspecifica}
                                    columnWidth='80%'
                                    notInverseOrder={true}
                                    toolTipX={false}
                                    toolTipXTotal={true}
                                    report={report}
                                    formatoReport={values.formatoReport}
                                    modoApresentacao={values.modoApresentacao}
                                    fillOpacity={0.7}//0.9
                                    //fillType='gradient'
                                    dataLabelsEnabled={true}
                                    dataLabelsEnabledReport={true}
                                    dataLabelsType="Medium"
                                    xaxisType={report ? "" : "Medium"} // mudança da fonte: xaxisType=Medium"
                                />
                            </GridItem8>

                            <GridItem3
                                className={report ? 'ml--8 mt-15' : 'ml--20 mt-20'}
                                ////className={report ? 'mt-4' : 'mt-15'}
                                ////align={report ? 'left' : 'center'}
                            >
                                <AnalisePatrimonialPieChart
                                    estudo={estudo}
                                    report={report}
                                    valorCSVidaInteira={valorCSVidaInteira}
                                    valorPremioAnualizadoVidaInteira={valorPremioAnualizadoVidaInteira}
                                />
                            </GridItem3>
                        </GridContainer>
                    </GridGrafico>
                        
                    <GridItem12>
                        <GridContainer
                            className='mt--5'////'mt-5'
                        >
                            <GridItem7 />

                            <GridItem5>
                                <GestaoPatrimonialFormResumoPatrimonialTotalAtivos
                                    values={values}
                                    estudo={estudo}
                                    report={report}
                                    popup={false}
                                    simulacaoFinanceira={false}
                                    analisePatrimonial={true}
                                    semAlavancagem={semAlavancagem}
                                />
                            </GridItem5>
                        </GridContainer>
                    </GridItem12>
                    
                    <GridGrafico>
                        <GridContainer
                            className={report ? '' : 'mt-5'}
                        >
                            <GridGraficoRecursosInstituicao>
                                <RecursosFinanceirosChart
                                    values={values}
                                    estudo={estudo}
                                    report={report}
                                    campoAgrupamento={HARDCODE.campoAgrupamentoInstituicao}
                                    valorPremioAnualizadoVidaInteira={valorPremioAnualizadoVidaInteira}
                                />
                            </GridGraficoRecursosInstituicao>

                            {/*////
                            <GridItem1/>

                            {report && (
                                <GridItem3/>
                            )}
                            */}

                            <GridGraficoRecursosDescricaoTipoFinanciamento>
                                <RecursosFinanceirosChart
                                    values={values}
                                    estudo={estudo}
                                    report={report}
                                    campoAgrupamento={HARDCODE.campoAgrupamentoDescricaoTipoRecursoFinanceiro}
                                    valorPremioAnualizadoVidaInteira={valorPremioAnualizadoVidaInteira}
                                />
                            </GridGraficoRecursosDescricaoTipoFinanciamento>
                        </GridContainer>
                    </GridGrafico>
                </GridContainer>
            //</div>
        )
    }

    return (
        <GridItem12>
            {report
                ?
                    <AnalisePatrimonial
                        //className='mt--5 ml-2' // mudança da fonte: mt-5
                    />
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.analisePatrimonial
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <AnalisePatrimonial/>
                        }
                        overflowX={false}
                        tabela={
                            <GestaoPatrimonialFormResumoPatrimonial
                                values={values}
                                estudo={estudo}
                                popup={true}
                                //popupGrafico={false}
                            />
                        }
                        tabelaTitle={LABEL.analisePatrimonial}
                        naoExibirTabela={naoExibirTabela}
                        modoApresentacao={values.modoApresentacao}
                        nameListaMoreLess={moreLessList}
                        listaMoreLess={moreLessList ? values[moreLessList] : ''}
                        idListaMoreLess={HARDCODE.analisePatrimonialChart}
                        setFieldValue={setFieldValue}
                    />
            }
        </GridItem12>
    )
}

export default AnalisePatrimonialChart